exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".crop-image{position:relative;height:100%;min-height:100vh;width:100%}.crop-image .crop-container{height:90%;background-color:#000}.crop-image .crop-container .cropped-image{background-color:#fff}.crop-image .controls{position:absolute;height:10%;bottom:0;width:100%;background-color:#2f2f2f;display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding:20px}.crop-image .controls button{font-size:18px;color:#ffffff;font-family:'SF-Pro-Display-Regular';font-weight:500;background:none;border:none;padding:0;cursor:pointer}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/components/CropImage/style.scss
// module id = 1436
// module chunks = 0